import React from 'react'
import { useTranslation } from 'react-i18next'
import SectionCard from '../../shared/SectionCard'
import StarRating from '../../shared/StarRating'
import './style.css'

const TopRatedDoctors = ({ topDoctors }) => {
    const { t } = useTranslation()

    return (
        <SectionCard icon="mdi:doctor" titleKey="top-rated-doctors">
            <div className="doctors-list">
                {topDoctors?.map(doctor => (
                    <div key={doctor.id} className="doctor-card">
                        <img 
                            src={doctor.avatar} 
                            alt={doctor.name} 
                            className="doctor-avatar"
                            onError={(e) => e.target.src = './images/doctor-placeholder.jpg'}
                        />
                        <div className="doctor-info">
                            <div className="doctor-name">{doctor.name}</div>
                            <div className="doctor-specialty">{doctor.specialty}</div>
                        </div>
                        <StarRating rating={doctor.rating} />
                        <a href="#" className="view-profile-link" onClick={(e) => e.preventDefault()}>
                            {t("view-profile")}
                        </a>
                    </div>
                ))}
            </div>
        </SectionCard>
    )
}

export default TopRatedDoctors

